import { render } from "./ProgressBarBGItem.vue?vue&type=template&id=236418a0&scoped=true"
import script from "./ProgressBarBGItem.vue?vue&type=script&lang=js"
export * from "./ProgressBarBGItem.vue?vue&type=script&lang=js"

import "./ProgressBarBGItem.vue?vue&type=style&index=0&id=236418a0&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236418a0"]])

export default __exports__